module.exports = __webpack_public_path__ + "static/media/balloon-v3@2x.d832890e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/balloon-v3@2x.png
// module id = 85
// module chunks = 0